import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsFinanceProductivity(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY,
		ModulesConfigMap[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY].GET_REGULATIONS_FINANCE_PRODUCTIVITY,
		options
	)
}
export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY].GET_REGULATIONS_FINANCE_PRODUCTIVITY]: _getRegulationsFinanceProductivity,
}